import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { BaseHeader } from '../header-elements/base-header';
import { HeaderRegion } from '../header-elements/header-region';
import { HeaderImageToolbar } from '../../header-image-toolbar';
export var HeaderMinimalTemplateA = function (props) {
  var headerData = props.headerData;
  return React.createElement(HeaderRegion, null, React.createElement(EGDSSpacing, {
    padding: {
      inlinestart: 'six',
      inlineend: 'two'
    }
  }, React.createElement(BaseHeader, {
    className: "global_navigation__header__default__max_width"
  }, React.createElement("div", null, React.createElement(HeaderImageToolbar, {
    headerImg: headerData.headerImg
  })))));
};